import * as ActionTypes from '../constants/ActionTypes';
import API from '../helpers/api';

export function getScanHistory(options) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_SCAN_HISTORY_REQUEST,
			payload: { loading: true }
		});

		const response = await API.scan_receipt.getScanHistory({ ...options });

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_SCAN_HISTORY_ERROR,
				payload: {
					meta: response.meta,
					loading: false
				}
			});
			return;
		}

		const { ai_jobs, total, page, limit } = response.data;

		dispatch({
			type: ActionTypes.GET_SCAN_HISTORY_SUCCESS,
			payload: {
				scanJobs: ai_jobs,
				total,
				page,
				limit,
				loading: false
			}
		});
	};
}

export function resetPage() {
	return dispatch => {
		dispatch({
			type: ActionTypes.RESET_SCAN_HISTORY_PAGE
		});
	};
}
